'use client';

import { useLayoutEffect, useRef, useState } from 'react';

const useSecondColumnFirstItem = (contentKey: string, isBrandLogo: boolean) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [secondColumnFirstChild, setSecondColumnFirstChild] = useState<HTMLElement | null>(null);

  const calculate = () => {
    const container = containerRef.current;
    if (!container) return;

    const firstChild = container.children[0];
    const children = Array.from(firstChild.children) as HTMLElement[];
    if (children.length === 0) return;

    // Find all elements that are visually in column 2 (left offset in middle range)
    const containerRect = firstChild.getBoundingClientRect();
    const colWidth = containerRect.width / 3; // 3 columns because of 33% width

    const col2Children = children
      .filter((child) => child.id !== 'template-1-layout-2-media')
      .filter((child) => child.id !== 'template1-logo')
      .filter((child) => {
        const rect = child.getBoundingClientRect();
        return rect.left >= containerRect.left + colWidth && rect.left < containerRect.left + colWidth * 2;
      });

    if (col2Children.length > 0) {
      setSecondColumnFirstChild(col2Children[0]);
    } else {
      setSecondColumnFirstChild(null);
    }
  };

  useLayoutEffect(() => {
    setSecondColumnFirstChild(null);
  }, [contentKey, isBrandLogo]);

  useLayoutEffect(() => {
    // Recalculate after every change in items
    // Delay ensures DOM updates (especially after remove)
    const timeout = setTimeout(() => calculate(), 100);

    return () => clearTimeout(timeout);
  }, [contentKey, isBrandLogo]);

  return { containerRef, secondColumnFirstChild };
};

export default useSecondColumnFirstItem;
